module.exports = __webpack_public_path__ + "img/swiper4_m.2f4ba42e.png";